<template>
  <v-dialog
    v-model="display"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    width="600px"
    max-height="400px"
    scrollable
    persistent
    class="rounded-0"
  >
    <v-card v-if="booking" class="mx-auto secondary rounded-0" elevation="0">
      <CardHeader
        :title="'Bookingnr. ' + booking.bookingno"
        icon="mdi-close"
        @iconClicked="disposeDialog"
      />
      <v-card-text style="height: 500px;">
        <v-row class="pa-0 pt-2 ma-0" no-gutters>
          <v-col cols="12">
            <span><b>Kundenr.: </b></span>
            <span>{{ booking.customerno }}</span>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0" no-gutters>
          <v-col cols="12">
            <span><b>Booker: </b></span>
            <span>{{ booking.bookername }}</span>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0" no-gutters>
          <v-col cols="12">
            <span><b>Biltype: </b></span>
            <span>{{ vehicleType }}</span>
          </v-col>
        </v-row>
        <v-row v-if="referencesVisible" class="pa-0 ma-0" no-gutters>
          <v-col cols="12">
            <span><b>Reference: </b></span>
            <span>{{ booking.reference }}</span>
          </v-col>
        </v-row>
        <v-container v-if="booking.stops.length === 2" class="pa-0 ma-0">
          <v-row class="pa-0 py-2 ma-0" no-gutters>
            <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6">
              <v-row class="pa-0 pr-2 ma-0" no-gutters>
                <v-col cols="12">
                  <span><b>Afhentning:</b></span>
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[0].address.name1 }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[0].address.address1 }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[0].instructions }}</span>
                </v-col>
                <v-col cols="12">
                  <span
                    >{{ booking.stops[0].address.zip }}
                    {{ booking.stops[0].address.city }}</span
                  >
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[0].address.country }}</span>
                </v-col>
                <v-col cols="12">
                  <span
                    >{{ booking.stops[0].fromtime | formatDateTime }} -
                    {{ booking.stops[0].totime | formatDateTime }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6">
              <v-row class="pa-0 pr-2 ma-0" no-gutters>
                <v-col cols="12">
                  <span><b>Levering:</b></span>
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[1].address.name1 }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[1].address.address1 }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[1].instructions }}</span>
                </v-col>
                <v-col cols="12">
                  <span
                    >{{ booking.stops[1].address.zip }}
                    {{ booking.stops[1].address.city }}</span
                  >
                </v-col>
                <v-col cols="12">
                  <span>{{ booking.stops[1].address.country }}</span>
                </v-col>
                <v-col cols="12">
                  <span
                    >{{ booking.stops[1].fromtime | formatDateTime }} -
                    {{ booking.stops[1].totime | formatDateTime }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="pa-0 py-2 ma-0" no-gutters>
            <v-col cols="12">
              <span><b>Gods:</b></span>
            </v-col>
            <v-col cols="12">
              <v-row
                v-for="goods in booking.goods"
                :key="goods.goodsno"
                class="pa-0 ma-0"
                no-gutters
              >
                <v-col
                  :cols="$vuetify.breakpoint.smAndDown ? 3 : 1"
                  class="mr-2 text-right"
                >
                  <span>{{ goods.cll | formatDouble }}</span>
                </v-col>
                <v-col
                  :cols="$vuetify.breakpoint.smAndDown ? 4 : 2"
                  class="mr-2 text-right"
                >
                  <span>{{ goods.grossweight | formatDouble }}kg</span>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
                  <span>{{ goods.description }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="booking.stops.length > 2" class="pa-0 ma-0">
          <v-row
            v-for="stop in booking.stops"
            :key="stop.stopsorder"
            class="pa-0 ma-0"
            no-gutters
          >
            <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
              <v-row class="pa-0 py-2 pr-2 ma-0" no-gutters>
                <v-col cols="12">
                  <span>
                    <b>Stopnr. {{ stop.stoporder + 1 }}</b></span
                  >
                </v-col>
                <v-col cols="12">
                  <span>{{ stop.address.name1 }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ stop.address.address1 }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ stop.instructions }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ stop.address.zip }} {{ stop.address.city }}</span>
                </v-col>
                <v-col cols="12">
                  <span>{{ stop.address.country }}</span>
                </v-col>
                <v-col cols="12">
                  <span
                    >{{ stop.fromtime | formatDateTime }} -
                    {{ stop.totime | formatDateTime }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
              <v-row class="pa-0 py-2 pr-2 ma-0" no-gutters>
                <v-col cols="12">
                  <span><b>Gods:</b></span>
                </v-col>
                <v-col cols="12">
                  <div v-for="goods in booking.goods" :key="goods.goodsno">
                    <v-row
                      v-if="
                        goods.pickupstoporder === stop.stoporder ||
                          goods.deliverystoporder === stop.stoporder
                      "
                      class="pa-0 ma-0"
                      no-gutters
                    >
                      <v-col :cols="$vuetify.breakpoint.smAndDown ? 1 : 1">
                        <span>{{
                          goods.pickupstoporder === stop.stoporder
                            ? "Afh."
                            : "Lev."
                        }}</span>
                      </v-col>
                      <v-col
                        :cols="$vuetify.breakpoint.smAndDown ? 2 : 2"
                        class="text-right"
                      >
                        <span>{{ goods.cll | formatDouble }}</span>
                      </v-col>
                      <v-col
                        :cols="$vuetify.breakpoint.smAndDown ? 3 : 3"
                        class="mr-5 text-right"
                      >
                        <span>{{ goods.grossweight | formatDouble }} kg</span>
                      </v-col>
                      <v-col :cols="$vuetify.breakpoint.smAndDown ? 5 : 5">
                        <span>{{ goods.description }}</span>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-row
          v-if="booking.price && priceVisible"
          class="pa-0 pt-2 ma-0"
          no-gutters
        >
          <v-col cols="12">
            <span><b>Pris:</b></span>
          </v-col>
          <v-col cols="12">
            <v-row
              v-for="pricedetails in booking.price.details"
              :key="pricedetails.description"
              class="pa-0 ma-0"
              no-gutters
            >
              <v-col :cols="$vuetify.breakpoint.smAndDown ? 8 : 10">
                <span>{{ pricedetails.description }}</span>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 4 : 2"
                class="text-right"
              >
                <span
                  >{{ pricedetails.price | formatDouble }}
                  {{ pricedetails.currency }}</span
                >
              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0" no-gutters>
              <v-col :cols="$vuetify.breakpoint.smAndDown ? 8 : 10">
                <span><b>Total</b></span>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 4 : 2"
                class="text-right"
              >
                <span
                  ><b
                    >{{ booking.price.totalprice | formatDouble }}
                    {{ booking.price.currency }}</b
                  ></span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn text class="text-left" @click="displayBookingEventsDialog()">
          Hændelser
        </v-btn>
        <v-btn text class="text-left" @click="print()">
          Print POD
        </v-btn>
        <v-btn @click="disposeDialog()">
          LUK
        </v-btn>
      </v-card-actions>
      <BookingEventsDialog
        :display="displayEvents"
        :booking="booking"
        :events="events"
        :callback="callbackBookingEventsDialog"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { dictionary, tools } from "@/helpers";
import CardHeader from "@/components/templates/CardHeader.vue";
import BookingEventsDialog from "@/components/dialogs/BookingEventsDialog.vue";

export default {
  name: "BookingDialog",
  components: {
    CardHeader,
    BookingEventsDialog
  },
  mounted() {
    const bookingType = this.$store.getters["user/bookingType"];
    const hidePrice = this.$store.getters["user/hidePrice"];
    this.priceVisible =
      !hidePrice &&
      bookingType !== dictionary.constants.booking_types.distribution;

    this.referencesVisible = !this.$store.getters["user/hideBookingReferences"];
  },
  data: () => ({
    displayEvents: false,
    events: []
  }),
  filters: {
    formatDateTime: function(datetime) {
      if (datetime) {
        const date = datetime.substr(0, 10);
        const time = datetime.substr(11, 5);
        return tools.formatDate(date) + " " + time;
      }
      return "";
    },
    formatDouble: function(val) {
      return tools.parseDoubleToString(parseFloat(val));
    }
  },
  computed: {
    display() {
      return this.$store.state.booking.displayBookingDialog;
    },
    booking() {
      return this.$store.state.booking.bookingForDisplay;
    },
    vehicleType() {
      let value = null;
      if (this.booking && this.booking.cartype) {
        this.$store.getters["user/vehicleTypes"].forEach(vehicleType => {
          if (
            vehicleType &&
            vehicleType.external_key &&
            vehicleType.external_key == this.booking.cartype
          ) {
            value = vehicleType;
          }
        });
      }
      return value ? value.name : "";
    }
  },
  methods: {
    disposeDialog() {
      this.$store.commit("booking/setBookingForDisplay", null);
      this.$store.commit("booking/setDisplayBookingDialog", false);
    },
    print() {
      window.open(this.booking.printurl, "_blank");
    },
    async displayBookingEventsDialog() {
      await this.loadEvents();
      this.displayEvents = true;
    },
    callbackBookingEventsDialog() {
      this.displayEvents = false;
      this.events = [];
    },
    async loadEvents() {
      this.events = [];
      const bookingNo = this.booking.bookingno;
      await this.$store.dispatch("booking/loadBookingEvents", bookingNo).then(
        response => {
          if (response && response.result && response.result.events) {
            response.result.events.forEach(event => {
              this.events.push(event);
            });
          }
        },
        error => {
          console.error(error);
        }
      );
    }
  }
};
</script>
